import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { getGUID, getTimeInUTC, formatPhoneNumber } from "./util";
import moment from "moment-timezone";
import { handle } from "@dp/common";

var Curbside = /*#__PURE__*/function () {
  function Curbside(config, axios) {
    _classCallCheck(this, Curbside);

    _defineProperty(this, "axios", void 0);

    _defineProperty(this, "config", void 0);

    this.axios = axios;
    this.config = config;
  } //TO DO add type check like CartTypes.FaultResponse and catch switch


  _createClass(Curbside, [{
    key: "getFaultCodesCheckSummary",
    value: function getFaultCodesCheckSummary(errorObj) {
      var _errorObj$response;

      var errResp = (errorObj === null || errorObj === void 0 ? void 0 : errorObj.errorResponse) || (errorObj === null || errorObj === void 0 ? void 0 : (_errorObj$response = errorObj.response) === null || _errorObj$response === void 0 ? void 0 : _errorObj$response.data);
      var faults = errResp === null || errResp === void 0 ? void 0 : errResp.Detail;

      if (faults) {
        if (Array.isArray(faults)) {
          return faults.map(function (fault) {
            return fault.FaultCode || fault.Description;
          });
        } else {
          return [faults.FaultCode || faults.Description];
        }
      } else {
        return [];
      }
    }
  }, {
    key: "getCheckSummary",
    value: function () {
      var _getCheckSummary = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(tkn) {
        var _response$data;

        var retryCount,
            _yield$handle,
            _yield$handle2,
            err,
            response,
            orderSummary,
            localTimezoneOffset,
            orderDateTime,
            pickUpDateTime,
            checkInDateTime,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                retryCount = _args.length > 1 && _args[1] !== undefined ? _args[1] : 2;
                _context.next = 3;
                return handle(this.axios.get((tkn === null || tkn === void 0 ? void 0 : tkn.length) > 12 ? this.config.postfix.CURBSIDE_CHECK_SUMMARY_APIv2 : this.config.postfix.CURBSIDE_CHECK_SUMMARY_API, {
                  params: {
                    tkn: tkn
                  },
                  headers: {
                    timeStamp: getTimeInUTC(),
                    sourceSystem: "DP",
                    trackingID: getGUID()
                  }
                }));

              case 3:
                _yield$handle = _context.sent;
                _yield$handle2 = _slicedToArray(_yield$handle, 2);
                err = _yield$handle2[0];
                response = _yield$handle2[1];
                orderSummary = response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.orderSummary;

                if (!(!err && orderSummary)) {
                  _context.next = 16;
                  break;
                }

                localTimezoneOffset = moment().toDate().getTimezoneOffset();

                if (orderSummary.orderDateTime) {
                  orderDateTime = moment(orderSummary.orderDateTime).toDate();
                  orderSummary.orderDateTime = moment(orderDateTime.getTime() + localTimezoneOffset * 60 * 1000).toDate();
                }

                if (orderSummary.pickUpDateTime) {
                  pickUpDateTime = moment(orderSummary.pickUpDateTime).toDate();
                  orderSummary.pickUpDateTime = moment(pickUpDateTime.getTime() + localTimezoneOffset * 60 * 1000).toDate();
                }

                if (orderSummary.checkInDateTime) {
                  checkInDateTime = moment(orderSummary.checkInDateTime).toDate();
                  orderSummary.checkInDateTime = moment(checkInDateTime.getTime() + localTimezoneOffset * 60 * 1000).toDate();
                }

                return _context.abrupt("return", response === null || response === void 0 ? void 0 : response.data);

              case 16:
                return _context.abrupt("return", this.handleCheckSummaryError(response, err, retryCount, tkn));

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getCheckSummary(_x) {
        return _getCheckSummary.apply(this, arguments);
      }

      return getCheckSummary;
    }()
  }, {
    key: "handleCheckSummaryError",
    value: function handleCheckSummaryError(response, err, retryCount, tkn) {
      if (retryCount > 0) {
        var newRetry = retryCount - 1;
        return this.getCheckSummary(tkn, newRetry);
      } else {
        if (err) {
          throw err;
        } else {
          return response.data;
        }
      }
    }
  }, {
    key: "getRestaurantDetailsByNumber",
    value: function () {
      var _getRestaurantDetailsByNumber = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(restaurantNumber) {
        var _response$data2, _response$data2$succe, _response$data3, _response$data3$succe;

        var response, restaurantDetails, currentDay, daysOfWeeks, currenDayIdx, weeklyHours, operatingHours, currentDayOpHoursArr, _currentDayOpHoursArr, _currentDayOpHoursArr2, restPhoneNumbers, primary, second, third;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.axios.get(this.config.postfix.CURBSIDE_RESTAURANT_NUMBER_API, {
                  params: {
                    restaurantNumber: restaurantNumber,
                    restNumFlag: true
                  }
                });

              case 2:
                response = _context2.sent;
                restaurantDetails = response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$succe = _response$data2.successResponse) === null || _response$data2$succe === void 0 ? void 0 : _response$data2$succe.restaurantDetails;

                if (restaurantDetails) {
                  currentDay = restaurantDetails.currentDay;
                  daysOfWeeks = restaurantDetails.daysOfWeeks;

                  if (daysOfWeeks) {
                    currenDayIdx = daysOfWeeks.reduce(function (res, dayOfWeek, idx) {
                      if (dayOfWeek.toUpperCase() === currentDay.toUpperCase()) {
                        res = idx + 1; // array idx + 1
                      }

                      return res;
                    }, -1);
                    restaurantDetails.currentDaySeq = currenDayIdx;
                  }

                  weeklyHours = restaurantDetails.weeklyHours;

                  if (weeklyHours) {
                    operatingHours = weeklyHours.filter(function (weeklyHour) {
                      return weeklyHour.hourCode === "OP";
                    });

                    if (restaurantDetails.currentDaySeq) {
                      currentDayOpHoursArr = operatingHours.filter(function (operatingHour) {
                        return operatingHour.dayOfWeek === restaurantDetails.currentDaySeq;
                      });

                      if (currentDayOpHoursArr && currentDayOpHoursArr.length > 0) {
                        restaurantDetails.currentDayHours = {
                          startTime: (_currentDayOpHoursArr = currentDayOpHoursArr[0].startTime) === null || _currentDayOpHoursArr === void 0 ? void 0 : _currentDayOpHoursArr.replace(/[AP]/, " $&"),
                          endTime: (_currentDayOpHoursArr2 = currentDayOpHoursArr[0].endTime) === null || _currentDayOpHoursArr2 === void 0 ? void 0 : _currentDayOpHoursArr2.replace(/[AP]/, " $&")
                        };
                      }
                    }
                  }

                  restPhoneNumbers = restaurantDetails.restPhoneNumber;
                  primary = this.getRestaurantPhoneNumberByType(restPhoneNumbers, "Primary");

                  if (primary) {
                    restaurantDetails.phoneNumber = formatPhoneNumber(primary.Phone);
                  } else {
                    second = this.getRestaurantPhoneNumberByType(restPhoneNumbers, "Secondary");

                    if (second) {
                      restaurantDetails.phoneNumber = formatPhoneNumber(second.Phone);
                    } else {
                      third = this.getRestaurantPhoneNumberByType(restPhoneNumbers, "Third");

                      if (third) {
                        restaurantDetails.phoneNumber = formatPhoneNumber(third.Phone);
                      }
                    }
                  }
                }

                return _context2.abrupt("return", response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : (_response$data3$succe = _response$data3.successResponse) === null || _response$data3$succe === void 0 ? void 0 : _response$data3$succe.restaurantDetails);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getRestaurantDetailsByNumber(_x2) {
        return _getRestaurantDetailsByNumber.apply(this, arguments);
      }

      return getRestaurantDetailsByNumber;
    }()
  }, {
    key: "getRestaurantPhoneNumberByType",
    value: function getRestaurantPhoneNumberByType(phoneNumbers, type) {
      if (phoneNumbers && phoneNumbers.length > 0) {
        var res = phoneNumbers.filter(function (phoneNumber) {
          return phoneNumber.useType === type;
        });
        return res.length > 0 ? res[0] : null;
      } else {
        return null;
      }
    }
  }, {
    key: "checkIn",
    value: function () {
      var _checkIn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(payload, channel) {
        var response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.axios.put(this.config.postfix.CURBSIDE_CHECK_IN_API, JSON.stringify(_objectSpread({
                  header: {
                    transactionTrackingID: getGUID(),
                    timeStamp: getTimeInUTC(),
                    sourceSystem: "DP",
                    channel: channel
                  }
                }, payload)));

              case 2:
                response = _context3.sent;
                return _context3.abrupt("return", response === null || response === void 0 ? void 0 : response.data);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function checkIn(_x3, _x4) {
        return _checkIn.apply(this, arguments);
      }

      return checkIn;
    }()
  }, {
    key: "notifyGuestAtRestaurantVicinity",
    value: function () {
      var _notifyGuestAtRestaurantVicinity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(payload) {
        var retryCount,
            _yield$handle3,
            _yield$handle4,
            err,
            response,
            nextRetryCount,
            _args4 = arguments;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                retryCount = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : 3;
                _context4.next = 3;
                return handle(this.axios.put(this.config.postfix.GUEST_AT_RESTAURANT_VICINITY, JSON.stringify({
                  header: {
                    transactionTrackingID: getGUID(),
                    timeStamp: getTimeInUTC(),
                    IPAddress: payload === null || payload === void 0 ? void 0 : payload.ipAddress,
                    source: {
                      system: "DP",
                      device: {
                        Uuid: payload === null || payload === void 0 ? void 0 : payload.deviceId
                      },
                      user: payload === null || payload === void 0 ? void 0 : payload.user
                    },
                    channel: payload.channel
                  },
                  corporationID: payload.corporationID,
                  locationNumber: payload.locationNumber,
                  orderIDs: payload.orderIDs,
                  action: payload.action,
                  geographicCoordinate: payload.userLocation
                }), {
                  headers: {
                    CorporationID: payload.corporationID,
                    LocationNumber: payload.locationNumber,
                    Concept: payload.concept
                  }
                }));

              case 3:
                _yield$handle3 = _context4.sent;
                _yield$handle4 = _slicedToArray(_yield$handle3, 2);
                err = _yield$handle4[0];
                response = _yield$handle4[1];

                if (!(!err && response)) {
                  _context4.next = 9;
                  break;
                }

                return _context4.abrupt("return", response === null || response === void 0 ? void 0 : response.data);

              case 9:
                if (retryCount > 0) {
                  nextRetryCount = retryCount - 1;
                  this.notifyGuestAtRestaurantVicinity(payload, nextRetryCount);
                }

              // handle error

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function notifyGuestAtRestaurantVicinity(_x5) {
        return _notifyGuestAtRestaurantVicinity.apply(this, arguments);
      }

      return notifyGuestAtRestaurantVicinity;
    }()
  }]);

  return Curbside;
}();

export { Curbside as default };